var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.overlapStyle)},[_vm._t("default"),_c('div',{staticClass:"bit-mark-wrap",style:({'background-image': `url(${_vm.base64URL})` ,'background-size': `${_vm.gapX}px ${_vm.gapY}px`})}),_c('canvas',{ref:"canvas",staticClass:"bit-watermark-canvas",attrs:{"width":"450","height":"320"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }